import flora from '../../data/flora.json';
const getAllFlora = () => {
    const all = [];
    for (const id of Object.keys(flora)) {
        all.push(flora[id]);
    }
    all.sort((a, b) => {
        if (a.type !== b.type) {
            return a.type < b.type ? -1 : 1;
        }
        return a.labels.en < b.labels.en ? -1 : 1;
    });
    return all;
};
export { getAllFlora };
